module.exports = __webpack_public_path__ + "img/DE00168.3033d460.png";